import React from "react"
import autobind from "class-autobind"
import { Dialog, TextField, FlatButton, CircularProgress} from "material-ui"
import { TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from "material-ui/Table"
import Table from "../../../components/common/Table"
import strings from "../../../localization/strings"
import Clear from "../../../components/misc/Clear"
import AccountStore from "../../../stores/AccountStore"
import AppStateStore from "../../../stores/AppStateStore"
import { ITestSubType } from "../../../models"
import * as api from "../../../api"

interface IProps {
	handleClose(): void
	handleSave(selectedClientType: string): void
}
interface IState {
	clientTypes: ITestSubType[]
	selectedClientType: ITestSubType
	search: string
	loading: boolean
	total: number
	offset: number
	limit: number
}

const styles = {
	nameCol: {
		paddingLeft: 5,
		paddingRight: 5,
		cursor: "pointer"
	},
	otherCol: {
		paddingLeft: 5,
		paddingRight: 5,
		width: 75
	}
}

export default class ChooseClientTypeDialogForChip extends React.Component<IProps, IState> {
	private ClientTypes: ITestSubType[]
	constructor(props) {
		super(props)
		this.ClientTypes = []
		this.state = {
			clientTypes: [],
			selectedClientType: null,
			search: "",
			loading: false,
			total: 0,
			offset: 0,
			limit: 8,
		}
		autobind(this)
	}

	componentDidMount() {
		this.getClientTypes()
	}

	getClientTypes() {
		this.setState({ loading: true }, () => {
			api.getClientTypes(AccountStore.getCurrentAccount().Id)
			.then(res => {
				this.ClientTypes = res.data.filter(clientType => clientType.Active) as ITestSubType[]
				this.setState({
					clientTypes: this.ClientTypes.slice(0, this.state.limit),
					total: this.ClientTypes.length,
					loading: false
				})
			})
			.catch(_err => {
				this.ClientTypes = []
				this.setState({
					clientTypes: [],
					total: this.ClientTypes.length,
					loading: false
				}, () => AppStateStore.setProgressSnackbarContent(strings.something_went_wrong))
			})
		})
	}

	// Updating the List for Client-Side Pagination & Searching
	updateClientTypes() {
		const filteredList = this.ClientTypes.filter(item => !this.state.search || item.Name.toLowerCase().includes(this.state.search.toLowerCase())).filter((_v, index) => index >= this.state.offset && index < this.state.offset + this.state.limit)
		if (this.state.search !== "") this.setState({ clientTypes: filteredList, total: filteredList.length })
		else this.setState({ clientTypes: filteredList, total: this.ClientTypes.length })
	}

	handleSelectClientTypes(selectedItems) {
		this.setState({ selectedClientType: selectedItems[0] })
	}

	ClientTypesTable = () => (
		!this.state.clientTypes.length ?
			<h2 style={{ textAlign: "center", marginTop: 25 }}>
			{strings.No_client_type_found}
			</h2> :
		<Table
			singleSelectable
			items={this.state.clientTypes}
			handleSelect={this.handleSelectClientTypes}
			total={this.state.total}
			offset={this.state.offset}
			limit={this.state.limit}
			limitOptions={[8, 20, 50]}
			onPageClick={offset => this.setState({ offset }, () => this.updateClientTypes())}
			onLimitChange={limit => this.setState({ offset: 0, limit }, () => this.updateClientTypes())}
		>
			<TableHeader>
				<TableRow>
					<TableHeaderColumn style={styles.nameCol}>{strings.Client_Type}</TableHeaderColumn>
				</TableRow>
			</TableHeader>
			<TableBody showRowHover deselectOnClickaway={false}>
				{this.state.clientTypes.map((item, index) =>
					<TableRow key={index} selected={this.state.selectedClientType && this.state.selectedClientType.Id === item.Id}>
						<TableRowColumn style={styles.nameCol} title={item.Name}>{item.Name}</TableRowColumn>
					</TableRow>
				)}
			</TableBody>
		</Table>
	)

	render() {
		return (
			<Dialog
				modal
				open
				title={strings.Choose_client_type}
				actions={[
					<FlatButton
						label={strings.Cancel}
						secondary
						onClick={this.props.handleClose}
					/>,
					<FlatButton
						label={strings.OK}
						primary
						keyboardFocused
						onClick={() => {
							this.props.handleSave(this.state.selectedClientType.Name)
						}}
					/>
				]}
				onRequestClose={this.props.handleClose}
			>
				<div style={{ padding: 20, paddingLeft: 35 }}>
					<i style={{ fontSize: 25 }} className="fa fa-search" />
					<TextField
						hintText={strings.search}
						style={{ marginRight: 20, width: "90%", marginLeft: 15 }}
						value={this.state.search}
						onChange={e => this.setState({ search: e.target.value, offset: 0 }, () => this.updateClientTypes())}
					/>
					<Clear />
				</div>
				<div style={{ textAlign: "center", height: "auto", minHeight: 520 }}>
					{this.state.loading ?
						<CircularProgress /> :
						<div>{this.ClientTypesTable()}</div>
					}
				</div>
			</Dialog>
		)
	}
}
